import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import logo from './st_mary_logo.jpg';
import './App.css';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createMuiTheme } from '@material-ui/core/styles';
import {useState} from 'react'

import { ThemeProvider } from '@material-ui/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import IconButton from '@material-ui/core/IconButton';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';


function Sidebar({sidebarOpen, setSidebarOpen}) {

  return (
      <SwipeableDrawer
        anchor="left"
        open={sidebarOpen}
        onClose={(e,v) => {setSidebarOpen(false)}}
        onOpen={(e,v) => {setSidebarOpen(true)}}
      >
      <List>
        {['Meeting Links', 'Recordings'].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      </SwipeableDrawer>
  );
}

export default Sidebar;
